
import React, { useState, useEffect } from "react";
import {
    Card,
    CardHeader,
    CardBody,
    Typography,
    Button,
    Spinner,

} from "@material-tailwind/react";
import { ToastContainer, toast } from 'react-toastify';
import { Navigate } from "react-router-dom";
import { useLocalStorage } from "../../hooks/useLocalStorage";
import { useShared } from "../../hooks/useShared";
import { useForm } from 'react-hook-form';
import AInput from "../../components/fields/AInput";
import AIcon from "../../components/partials/AIcon";
import login_bg from './../../assets/images/login_bg.jpg'
import logo_h from './../../assets/images/logo_h.jpeg'

export default function ResetPasswordByEmail() {
    const {
        register,
        handleSubmit,
        control,
        setValue,
        formState: { errors },
    } = useForm();


    const [loading, setLoading] = useState(false)
    const [errMsg, setErrMsg] = useState(null)
    const [successMsg, setSuccessMsg] = useState(null)
    const [user, setUser] = useLocalStorage("user", null);


    const { auth, http, navigate, location } = useShared();
    console.log('AuthScreen ', user);

    useEffect(() => {
        console.log(new URLSearchParams(location.search).get('email'));
        setValue("email", new URLSearchParams(location.search).get('email'))
        setValue("passwordToken", new URLSearchParams(location.search).get('token'))
        setValue("password", 'test') // just to pass the rest password rules in backend
    }, [])


    if (user) {
        return <Navigate to="/db/dashboard" />;
    }


    const resetPawssord = (data) => {
        setLoading(true);
        setErrMsg(null);
        setSuccessMsg(null);
        console.log("resetPawssord ", data);
        http.post(`api/reset-password`, data).then(res => {
            console.log(res);
            if (res?.data?.success) {
                setLoading(false)
                setSuccessMsg(res?.data?.message)
                toast.success(res?.data?.message)
            }
        }, error => {


            setLoading(false)
            console.log(error);

            const err = error?.response?.data

            if (!err?.success) {
                setErrMsg(err?.message)
            }

        })
    }



    return (
        <div className="grid place-items-center h-screen bg-red-200  bg-no-repeat bg-cover" style={{ backgroundImage: `url(${login_bg})` }}>

            <Card className="w-full max-w-[24rem] bg-white/90 md:bg-white/70">
                <CardHeader
                    floated={false}
                    shadow={false}
                    className="m-0 grid place-items-center rounded-b-none p-2 text-center bg-main-color"
                >
                    <div className="rounded-xl border border-white/10 bg-white/10 p-2 text-white">

                        <img
                            src={logo_h}
                            alt="test"
                            className="h-20 w-[100%] bg-gray-200 border   rounded-md"
                        />
                    </div>
                </CardHeader>
                <CardBody>
                    <form autoComplete="off" className=" flex flex-col gap-4" onSubmit={handleSubmit(resetPawssord)}>

                        <h1 className="text-center font-bold">Reset Your Password</h1>
                        {successMsg == null && <div className=" grid  gap-6 items-baseline">
                            <AInput v={{ register, errors, control, data: { label: 'ايميل', name: 'email', type: 'email', isStyle: true, required: "Email address is required.", icon: 'at-sharp', isDisabled: true, hide:true } }} />
                            <AInput v={{ register, errors, control, data: { label: 'پاسورد جديد', name: 'new_password', type: 'password', isStyle: true, required: "Password is required.", icon: 'eye-outline' } }} />
                            <AInput v={{ register, errors, control, data: { label: 'تکرار پاسورد جديد', name: 'new_password_confirmation', type: 'password', isStyle: true, required: "Password confirmation is required.", icon: 'eye-outline' } }} />

                        </div>}

                        {errMsg && <Typography
                            variant="small"
                            color="gray"
                            className="flex items-center text-red-500 gap-2 font-normal mt-5"
                        >
                            <AIcon name="alert-circle-outline" className="-mt-0.5 h-4 w-4" />
                            {errMsg}
                        </Typography>}

                        {successMsg && <Typography
                            variant="small"
                            color="gray"
                            className="flex items-center text-green-700 gap-2 font-normal mt-5"
                        >
                            <AIcon name="checkmark-done-sharp" className="-mt-0.5 h-4 w-4" />
                            {successMsg}
                        </Typography>}
                        <div className="flex justify-between">
                            <Button
                                variant="outlined"
                                color="green"
                                onClick={() => navigate("/db/login")}
                                className="mr-1 px-2 py-1"
                            >
                                <span>Login</span>
                            </Button>
                            <Button className="bg-main-color py-2 shrink  w-32" type="submit" >
                                {loading ? <Spinner color="teal" className="h-4 w-4" /> : "ارسال"}
                            </Button>
                        </div>

                    </form>
                </CardBody>
            </Card>

            <ToastContainer />
        </div>


    );
}

